import { MockService } from '../../../core/services/mock.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';
import { Observable, map, delay, catchError, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { IrisoCondition } from '../models/iriso.model';
import { Response } from '../models/stock-summary-master.model';
import { Iriso, InterCorpIrisoRequest, InterCorpIrisoResponse, VendorCategoryItem } from '../models/iriso.model';
import { Option } from 'src/app/base/models/option.model';

@Injectable({
  providedIn: 'root',
})
export class IrisoService {
  // 測試範例為了模擬資料查詢時間，實際開發不會用到
  delay: number = 1000;

  constructor(
    private readonly mockService: MockService,
    private readonly httpClient: HttpClient
  ) {}

  getIriso(data?: IrisoCondition): Observable<Response> {
    let endpoint = `${environment.apiEndpoint}/pbk-details/iriso`;
    endpoint = this.mockService.parseApiEndpoint(
      endpoint,
      '/api/v1/item360/iriso.json'
    );
    
    if (environment.apiMock) {
      return this.httpClient.get<Response>(endpoint);
    }

    return this.httpClient
      .post<Response>(endpoint, data)
      .pipe(map((data) => data));
  }

  queryInterCorpIriso(request: InterCorpIrisoRequest): Observable<InterCorpIrisoResponse> {
    const endpoint = `${environment.apiEndpoint}/inter-corp-iriso/queryInterCorpIriso`;
    return this.httpClient.post<InterCorpIrisoResponse>(endpoint, request);
  }

  getVendorCategories(brand: string): Observable<Option[]> {
    const endpoint = `${environment.commonApiEndpoint}/itemBrandCtg/allCtg/${encodeURIComponent(brand)}?includeAll=false&onlyActive=true`;
    return this.httpClient.get<VendorCategoryItem[]>(endpoint).pipe(
      map(items => items.map(item => {
        const parts = [item.ctg1, item.ctg2, item.ctg3].filter(v => v != null && v !== '');
        const combined = parts.join('.');
        return {
          id: combined,
          value: combined,
          label: combined,
        };
      }))
    );
  }
}
